<template>
  <v-container fluid>
    <v-row>
      <v-spacer></v-spacer>
      <v-col sm="3">
        <v-layout row wrap>
          <v-flex xs5 pt-3>
            <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    outlined
                    dense
                    class="text1"
                    v-model="date1Formatted"
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="date1"
                  @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs5 pt-3 ml-2>
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    class="text2"
                    v-model="date2Formatted"
                    outlined
                    dense
                    readonly
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="date2"
                  @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 pt-3 class="ml-1">
            <v-btn small color="#112A46" dark height="38px" @click="getPosts"
            >Go
            </v-btn
            >
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
    <v-row
        v-if="allPost.length == 0"
        align="center"
        class="text-center"
        style="min-height:200px;"
    >
      <v-col>
        <h1 class="display-2 grey--text" style="text-align:center">
          No Posts Found
        </h1>
      </v-col>
    </v-row>
    <v-row v-else mb-4>
      <v-col v-for="(post, index) in allPost" :key="index" cols="3" xl="3" lg="4" md="4" sm="4">
        <div  class="p-3 m-t-3 shadow-2 bg-white rounded-3">
          <v-img
              class="rounded-2"
              v-if="post.post_media[0] && post.post_media[0].media != ''"
              height="255"
              :src="s3BucketURL + post.post_media[0].media"
              @click="showPostModel(post.id)"
              style="cursor: pointer;"
          >
          </v-img>
          <v-img
              class="rounded-2"
              v-else
              height="255"
              src="./../../../assets/images/default_images/image_default.jpg"
              @click="showPostModel(post.id)"
              style="cursor: pointer;"

          >
          </v-img>
          <div style="cursor: pointer;" @click="showPostModel(post.id)" class="m-t-2">
            <v-row>
              <v-col cols="12" class="pb-0 pt-0">
                <h3 class="mt-3">
                  {{ post.title }}
                </h3>
                <h4 class="mt-3">
                  {{ post.description }}
                </h4>
              </v-col>
              <v-col cols="12" class="py-1" height="20px">
                <v-list-item-icon class="mt-1 mb-3 mr-0">
                  <SvgIcon>
                    <template #icon>
                      <CalendarIcon></CalendarIcon>
                      {{ post.created_date | dayDateFormat }} - {{ post.created_time | timeFormat }}
                    </template>

                  </SvgIcon>
                </v-list-item-icon>
              </v-col>
            </v-row>
          </div>
          <div style="height:40px" class="pt-4">
            <div class="d-flex gap-x-4">
              <SvgIcon
                  :text="post.likes != null ? post.likes.length : 0 "
                  class="pointer"
              >
                <template #icon>
                  <LikeIcon
                      @click="showLikedUsers(post.id)"
                  />
                </template>
              </SvgIcon>
              <SvgIcon
                  :text="post.comments.length"
                  class="pointer"
              >
                <template #icon>
                  <CommentIcon
                      @click="showCommentedUsers(post.id)"
                  />
                </template>
              </SvgIcon>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Comment -->
    <v-dialog v-model="comment_dialogue" width="500">
      <v-card>
        <v-card-title class="headline" primary-title>Comments</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(comment, index) in all_comments" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ comment.name }}</v-list-item-title>
                {{ comment.comment }}
              </v-list-item-content>

              <v-list-item-avatar>
                <v-img :src="imageUrl + comment.picture"></v-img>
              </v-list-item-avatar>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="comment_dialogue = false"
          >OK
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Like -->
    <v-dialog v-model="like_dialogue" width="500">
      <v-card>
        <v-card-title class="headline" primary-title>Likes</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(like, index) in all_likes" :key="index">
              <v-list-item-content>
                <v-list-item-title>{{ like.name }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-avatar>
                <v-img
                    v-if="like.picture"
                    :src="imageUrl + like.picture"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="like_dialogue = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <post-model v-bind="postModel" @close="postModel.postID = null"/>
    <liked-users-model
        v-bind="likedUsersModel"
        @close="likedUsersModel.postID = null"
    />
    <commented-users-model
        v-bind="commentedUsersModel"
        @close="commentedUsersModel.postID = null"
    />

    <v-pagination
        v-if="totalPages > 1"
        class="mt-3"
        v-model="page"
        :length="totalPages"
    ></v-pagination>
  </v-container>
</template>
<script>
import PostModel from "./../../Feeds/Post/PostModel";
import LikedUsersModel from "./../../Feeds/Post/LikedUsersModel";
import CommentedUsersModel from "./../../Feeds/Post/CommentedUsersModel";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import LikeIcon from "@/assets/images/misc/like.svg";
import CommentIcon from "@/assets/images/misc/comment.svg";
import CalendarIcon from "@/assets/images/misc/calendar.svg";
import moment from "moment";

export default {
  components: {
    PostModel,
    SvgIcon,
    LikeIcon,
    CalendarIcon,
    CommentIcon,
    LikedUsersModel,
    CommentedUsersModel,
  },
  data() {
    return {
      like_dialogue: false,
      comment_dialogue: false,
      all_likes: [],
      all_comments: [],
      allPost: [],
      date1: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      menu1: false,
      menu2: false,
      search: null,
      page: 1,
      perPage: null,
      totalPages: 1,
      postID: null,
      postModel: {postID: null, type: "details"},
      likedUsersModel: {postID: null, type: "details"},
      commentedUsersModel: {postID: null, type: "details"},
    };
  },
  props: {
    userID: {type: Number},
  },
  mounted() {
    this.search = null;
    this.page = 1;
    this.getPosts();
  },
  computed: {
    date1Formatted() {
      return moment(this.date1, "YYYY-MM-DD").format("Do MMM YYYY");
    },
    date2Formatted() {
      return moment(this.date2, "YYYY-MM-DD").format("Do MMM YYYY");
    },
  },
  watch: {
    userID() {
      this.search = null;
      this.page = 1;
      this.getPosts();
    },
    search() {
      this.page = 1;
      this.getPosts();
    },
    page() {
      this.getPosts();
    },
  },
  methods: {
    showPostModel(postId) {
      this.postModel.postID = parseInt(postId);
      this.postModel.type = "details";
    },
    getPosts() {
      this.showLoader('Loading');
      let url =
          "&page=" +
          this.page +
          "&per_page=8&from_date=" +
          this.date1 +
          "&end_date=" +
          this.date2;
      if (this.search != null && this.search != "") {
        url += "&term=" + this.search;
      }
      this.$http
          .get("admin/user-posts?user_id=" + this.userID + url)
          .then((response) => {
            if (response.status == 200 && response.data.status) {
              this.allPost = response.data.data;
              this.totalPages = response.data.total_pages;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          }).finally(() => {
            this.hideLoader()
      });
    },

    showLikedUsers(postId) {
      this.likedUsersModel.postID = parseInt(postId);
      this.likedUsersModel.type = "details";
    },
    showCommentedUsers(postId) {
      this.commentedUsersModel.postID = parseInt(postId);
      this.commentedUsersModel.type = "details";
    },
  },
};
</script>

<style>
.post_headings {
  background: rgb(0, 0, 0);
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.11) 0%,
      rgba(0, 0, 0, 0.4) 23%,
      rgba(0, 0, 0, 0.5) 72%,
      rgba(0, 0, 0, 0) 99%
  );
  color: #fff;
}

.fleft {
  float: left;
}

.badge {
  position: absolute;
  top: 6px;
}

.fright {
  float: right;
}

.like-comment,
v-img {
  filter: grayscale(100%);
}

.like-comment:hover {
  color: rgb(19, 109, 226);
  filter: grayscale(0%);
}
</style>
